






































import { PartyProductModel } from '@/libs/Api';
import { Guid } from '@/libs/common/functions/guid';
import {Component, Vue, Prop, Ref} from 'vue-property-decorator';
import ClientInsuarenceDialog from '@/libs/account/components/ClientInsuarenceDialog.vue';
import RequestForQuotationDialog from '@/libs/account/components/RequestForQuotationDialog.vue';

@Component({
    components: {
        ClientInsuarenceDialog,
        RequestForQuotationDialog
    }
})
export default class ClientInsuaranceCard extends Vue {


    @Prop() partyProduct!: PartyProductModel;
    @Prop() clientId!: string;
    @Ref() dialog!: ClientInsuarenceDialog;
    
    newId: string | null = Guid.EmptyGuid();

    openPartyProduct() {
        if (this.partyProduct.id == this.newId)
            return;
        this.dialog.open();
    }

}

